interface ComponentProps {
    title: string;
}
export const HighLightTitleHeading: React.FC<ComponentProps> = ({ title }) => {

    return (
        
        <h2 className={"text-3xl md:text-4xl font-bold uppercase font-barlow-semi-condensed text-zinc-800 mb-6 leading-tight"}>{title}</h2>
       
    );
};